// extracted by mini-css-extract-plugin
export default {"resale-search":"SearchInput_resale-search__aLQKs","cross-icon":"SearchInput_cross-icon__tSZ3l"};